import { StockConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case StockConstant.SET_STOCKS:
      return { ...state, list: payload };
    default:
      return state;
  }
};
